/* NgRx */
import {createAction, props} from '@ngrx/store';
import {ContractsModel} from "../../../../models/contracts.model";
import {
  FetchContractDetailsModel
} from "../models/fetch-contract-details.model";
import {
  UpdateContractDetailsModel
} from "../models/update-contract-details.model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[contracts] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH CONTRACT DETAILS ***********/
const FETCH_CONTRACT_DETAILS_REQUEST = '[contracts] fetch contract details requested';
export const FetchContractDetailsRequest = createAction(FETCH_CONTRACT_DETAILS_REQUEST, props<{
  payload: FetchContractDetailsModel['request']
}>());

const FETCH_CONTRACT_DETAILS_SUCCESS = '[contracts] fetch contract details successful';
export const FetchContractDetailsSuccess = createAction(FETCH_CONTRACT_DETAILS_SUCCESS, props<{
  contractDetails: ContractsModel
  message: string
}>());

const FETCH_CONTRACT_DETAILS_FAILURE = '[contracts] fetch contract details failure';
export const FetchContractDetailsFailure = createAction(FETCH_CONTRACT_DETAILS_FAILURE);

/******** UPDATE CONTRACT DETAILS ***********/
const UPDATE_CONTRACT_DETAILS_REQUEST = '[contracts] update contract details requested';
export const UpdateContractDetailsRequest = createAction(UPDATE_CONTRACT_DETAILS_REQUEST, props<{
  payload: UpdateContractDetailsModel['request'],
  previousUrl: string
}>());

const UPDATE_CONTRACT_DETAILS_SUCCESS = '[contracts] update contract details successful';
export const UpdateContractDetailsSuccess = createAction(UPDATE_CONTRACT_DETAILS_SUCCESS, props<{
  contractDetails: ContractsModel
  message: string
}>());

const UPDATE_CONTRACT_DETAILS_FAILURE = '[contracts] update contract details failure';
export const UpdateContractDetailsFailure = createAction(UPDATE_CONTRACT_DETAILS_FAILURE);
